// Card #2823 (scribe-resilience G11) — gzip a JSON-serializable value for
// the station snapshot upload's wire body. CompressionStream("gzip") is
// native in every browser scribe-fe's kiosk target runs (real Chrome, per
// CLAUDE.md's screenshot-verification rule) and needs no bundled
// dependency. When it is unavailable (an older engine, a test environment
// without it) this falls back to returning the plain JSON string, unzipped
// — score-api's intake (apps/score-api/src/lib/station-snapshot.js
// gunzipStationSnapshotBody) already accepts a plain body with no
// Content-Encoding header, so the caller sending that string as-is is a
// correct, if larger, upload rather than a failure.
export async function gzipJson(value) {
  const json = JSON.stringify(value);
  if (typeof CompressionStream === "undefined") {
    return { body: json, gzipped: false };
  }
  const bytes = new TextEncoder().encode(json);
  const cs = new CompressionStream("gzip");
  const writer = cs.writable.getWriter();
  // Fire-and-forget the write itself; the read side (Response(...).arrayBuffer())
  // below is what actually drives the stream to completion.
  writer.write(bytes);
  writer.close();
  const compressed = await new Response(cs.readable).arrayBuffer();
  return { body: compressed, gzipped: true };
}

export default gzipJson;
